module.exports = __webpack_public_path__ + "img/banner2_3_th.77cbacaa.png";